"use client"

import Link from "next/link"
import { Facebook, Linkedin, Instagram, Mail, Phone, MapPin, ChevronRight } from "lucide-react"
// import { FaWhatsapp } from "react-icons/fa";
import { Input } from "@/components/ui/input"
import { motion } from "framer-motion"

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white pt-12 md:pt-20 pb-6 md:pb-8 relative overflow-hidden">
      {/* Background Elements - hidden on mobile */}
      <div className="absolute inset-0 overflow-hidden hidden md:block">
        <motion.div
          className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.2, 1],
            x: [0, 30, 0],
            y: [0, -30, 0],
          }}
          transition={{ duration: 15, repeat: Number.POSITIVE_INFINITY }}
        />
        <motion.div
          className="absolute bottom-0 left-0 w-80 h-80 bg-white/5 rounded-full blur-3xl"
          animate={{
            scale: [1, 1.3, 1],
            x: [0, -20, 0],
            y: [0, 20, 0],
          }}
          transition={{ duration: 20, repeat: Number.POSITIVE_INFINITY, delay: 2 }}
        />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-16">
          {/* Column 1 - About */}
          <div>
            <h3 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-white">
              Let us tell your brand&apos;s story
            </h3>
            <p className="text-gray-300 mb-4 md:mb-6 text-sm md:text-base">
              Annual ESG specializes in creating visually stunning and strategically crafted corporate reports that
              effectively communicate your company's story.
            </p>
            <Link href="#contact" className="bg-white hover:bg-gray-100 text-gray-800 rounded-full px-5 py-2 shadow-lg group text-sm md:text-base">
              GET IN TOUCH
              <ChevronRight className="ml-1 w-4 h-4 inline transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6 text-white">Quick Links</h3>
            <ul className="grid grid-cols-2 md:block gap-2 md:space-y-3">
              {["About", "Services", "Portfolio", "Process", "Testimonials", "Contact"].map((item, i) => (
                <li key={i}>
                  <Link
                    href={`#${item.toLowerCase()}`}
                    className="text-gray-300 hover:text-white transition-colors flex items-center group text-sm md:text-base"
                  >
                    <ChevronRight className="w-3 h-3 md:w-4 md:h-4 mr-1 md:mr-2 transition-transform group-hover:translate-x-1" />
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3 - Contact Info */}
          {/* <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6 text-white">Contact Info</h3>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 mt-1 flex-shrink-0">
                  <MapPin className="w-3 h-3 md:w-4 md:h-4 text-white" />
                </div>
                <span className="text-gray-300 text-sm md:text-base">
                  203, BSI Business Park, H-160, H Block, Sector 63, Noida, Uttar Pradesh 201301, India.
                </span>
              </li>
              <li className="flex items-center">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                  <Phone className="w-3 h-3 md:w-4 md:h-4 text-white" />
                </div>
                <span className="text-gray-300 text-sm md:text-base">+91 94119 53348 (India)</span>
              </li>
              <li className="flex items-center">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                  <FaWhatsapp className="w-3 h-3 md:w-5 md:h-5 text-white" />
                </div>
                <span className="text-gray-300 text-sm md:text-base">+91 94119 53348</span>
              </li>
              <li className="flex items-center">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                  <Mail className="w-3 h-3 md:w-4 md:h-4 text-white" />
                </div>
                <a href="mailto:contact@annualesg.com" className="text-gray-300 text-sm md:text-base hover:underline">
                  contact@annualesg.com
                </a>
              </li>

            </ul>
          </div> */}




          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6 text-white">Contact Info</h3>
            <ul className="space-y-3 md:space-y-4">
              <li className="flex items-start">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 mt-1 flex-shrink-0">
                  <MapPin className="w-3 h-3 md:w-4 md:h-4 text-white" />
                </div>
                <span className="text-gray-300 text-sm md:text-base">
                  BSI Business Park, H-160, H Block, Sector 63, Noida, Uttar Pradesh 201301, India.
                </span>
              </li>
              <li className="flex items-center">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                  <Phone className="w-3 h-3 md:w-4 md:h-4 text-white" />
                </div>
                <a href="tel:+919411953348" className="text-gray-300 text-sm md:text-base hover:underline">
                  +91 94119 53348 (India)
                </a>
              </li>
              {/* <li className="flex items-center">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                  <FaWhatsapp className="w-3 h-3 md:w-5 md:h-5 text-white" />
                </div>
                <a
                  href="https://wa.me/919411953348"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 text-sm md:text-base hover:underline"
                >
                  +91 94119 53348
                </a>
              </li> */}
              <li className="flex items-center">
                <div className="bg-white/20 p-1.5 md:p-2 rounded-full mr-2 md:mr-3 flex-shrink-0">
                  <Mail className="w-3 h-3 md:w-4 md:h-4 text-white" />
                </div>
                <a
                  href="mailto:contact@annualesg.com"
                  className="text-gray-300 text-sm md:text-base hover:underline"
                >
                  contact@annualesg.com
                </a>
              </li>
            </ul>
          </div>





          {/* Column 4 - Newsletter */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4 md:mb-6 text-white">Newsletter</h3>
            <p className="text-gray-300 mb-3 md:mb-4 text-sm md:text-base">
              Subscribe to our newsletter for the latest updates and insights on corporate reporting.
            </p>
            <div className="flex space-x-2">
              <Input
                placeholder="Your email"
                className="bg-gray-700 border-gray-600 focus:border-white text-white rounded-full text-sm md:text-base placeholder:text-gray-400"
              />
              <button className="bg-white hover:bg-gray-100 text-gray-800 rounded-full px-3 md:px-4 py-2 text-sm md:text-base whitespace-nowrap">
                Subscribe
              </button>
            </div>


            <div className="flex space-x-3 md:space-x-4 mt-4 md:mt-6">

              <Link
                href="https://www.facebook.com/annualesg/"
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white hover:text-gray-800 transition-colors"
              >
                <Facebook size={16} />
              </Link>
              <Link
                href="https://www.linkedin.com/company/annual-esg/"
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white hover:text-gray-800 transition-colors"
              >
                <Linkedin size={16} />
              </Link>
              <Link
                href="https://www.instagram.com/annual_esg/"
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white hover:text-gray-800 transition-colors"
              >
                <Instagram size={16} />
              </Link>
              {/* <Link
                href="#"
                className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white hover:text-gray-800 transition-colors"
              >
                <Twitter size={16} />
              </Link> */}
            </div>


          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-6 md:pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center text-gray-400 text-xs md:text-sm">
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 md:gap-4 mb-3 md:mb-0">
            <p>© 2025 Annual ESG</p>
            <span className="hidden md:inline">|</span>
            <p>All Rights Reserved</p>
            <span className="hidden md:inline">|</span>
            <Link href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </div>


          <p>Designed & Developed with ❤️ by <Link href="https://www.bunnx.com/">Bunnx</Link> </p>
        </div>
      </div>
    </footer>
  )
}
